module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_7005.facaa1bf.png";